var path = 'infrastructure/controllers/views/alert-dialog.html';
var html = "<div class=modal-header> <i class=\"fa fa-warning\"></i> </div> <div class=modal-title> {{ options.title }} </div> <form> <div class=modal-body> <div ng-bind-html=options.message></div> </div> <div class=modal-footer> <button class=btn ng-click=close()>Close</button> </div> </form> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/controllers/views/alert-dialog.html
// module id = 22916695967575
// module chunks = 1